import { render } from "./GamificationLeaderboard.vue?vue&type=template&id=420bddd8"
import script from "./GamificationLeaderboard.vue?vue&type=script&lang=js"
export * from "./GamificationLeaderboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__